import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { TrailerDetailEtaFetchProps } from 'types/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'
import { fetchStoreTrailerEta } from 'queries/trailer/trailer-eta'

export function useStoreTrailerEta({
    env,
    accessToken,
    filters,
}: TrailerDetailEtaFetchProps) {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.TRAILER_ETA, filters],
        () =>
            fetchStoreTrailerEta({
                env,
                accessToken,
                filters,
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
